"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  getLightStyle: true,
  getAmbianceEffect: true,
  getSortedLightingEffects: true,
  getSpecialEffect: true,
  isAmbianceEffectId: true,
  isFlashingAmbiance: true,
  isSpecialEffectId: true,
  getAnalyticsOverview: true,
  sumPointsObject: true,
  getQuestionsAnswerStats: true,
  getStudentQuestionAnswerStats: true,
  getPerformanceScoresForStudent: true,
  getMissionPerformanceScores: true,
  didAnalyticsDocumentPass: true,
  getAnalyticsVersionDescription: true,
  getCondensedActionGraph: true,
  populateMediaDurationOnActions: true,
  getScanTimeScale: true,
  getTimelineOfMissionThroughSimulation: true,
  assignStudentsToTeams: true
};
Object.defineProperty(exports, "assignStudentsToTeams", {
  enumerable: true,
  get: function () {
    return _assignment.assignStudentsToTeams;
  }
});
Object.defineProperty(exports, "didAnalyticsDocumentPass", {
  enumerable: true,
  get: function () {
    return _analytics.didAnalyticsDocumentPass;
  }
});
Object.defineProperty(exports, "getAmbianceEffect", {
  enumerable: true,
  get: function () {
    return _specialEffects.getAmbianceEffect;
  }
});
Object.defineProperty(exports, "getAnalyticsOverview", {
  enumerable: true,
  get: function () {
    return _analytics.getAnalyticsOverview;
  }
});
Object.defineProperty(exports, "getAnalyticsVersionDescription", {
  enumerable: true,
  get: function () {
    return _versionDescription.getAnalyticsVersionDescription;
  }
});
Object.defineProperty(exports, "getCondensedActionGraph", {
  enumerable: true,
  get: function () {
    return _graphs.getCondensedActionGraph;
  }
});
Object.defineProperty(exports, "getLightStyle", {
  enumerable: true,
  get: function () {
    return _lightStyles.getLightStyle;
  }
});
Object.defineProperty(exports, "getMissionPerformanceScores", {
  enumerable: true,
  get: function () {
    return _analytics.getMissionPerformanceScores;
  }
});
Object.defineProperty(exports, "getPerformanceScoresForStudent", {
  enumerable: true,
  get: function () {
    return _analytics.getPerformanceScoresForStudent;
  }
});
Object.defineProperty(exports, "getQuestionsAnswerStats", {
  enumerable: true,
  get: function () {
    return _analytics.getQuestionsAnswerStats;
  }
});
Object.defineProperty(exports, "getScanTimeScale", {
  enumerable: true,
  get: function () {
    return _sensors.getScanTimeScale;
  }
});
Object.defineProperty(exports, "getSortedLightingEffects", {
  enumerable: true,
  get: function () {
    return _specialEffects.getSortedLightingEffects;
  }
});
Object.defineProperty(exports, "getSpecialEffect", {
  enumerable: true,
  get: function () {
    return _specialEffects.getSpecialEffect;
  }
});
Object.defineProperty(exports, "getStudentQuestionAnswerStats", {
  enumerable: true,
  get: function () {
    return _analytics.getStudentQuestionAnswerStats;
  }
});
Object.defineProperty(exports, "getTimelineOfMissionThroughSimulation", {
  enumerable: true,
  get: function () {
    return _paths.getTimelineOfMissionThroughSimulation;
  }
});
Object.defineProperty(exports, "isAmbianceEffectId", {
  enumerable: true,
  get: function () {
    return _specialEffects.isAmbianceEffectId;
  }
});
Object.defineProperty(exports, "isFlashingAmbiance", {
  enumerable: true,
  get: function () {
    return _specialEffects.isFlashingAmbiance;
  }
});
Object.defineProperty(exports, "isSpecialEffectId", {
  enumerable: true,
  get: function () {
    return _specialEffects.isSpecialEffectId;
  }
});
Object.defineProperty(exports, "populateMediaDurationOnActions", {
  enumerable: true,
  get: function () {
    return _actions.populateMediaDurationOnActions;
  }
});
Object.defineProperty(exports, "sumPointsObject", {
  enumerable: true,
  get: function () {
    return _analytics.sumPointsObject;
  }
});
var _missionStateSelectors = require("./missionStateSelectors");
Object.keys(_missionStateSelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _missionStateSelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _missionStateSelectors[key];
    }
  });
});
var _simulation = require("./simulation");
Object.keys(_simulation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _simulation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _simulation[key];
    }
  });
});
var _lightStyles = require("./specialEffectDefinitions/lightStyles");
var _specialEffects = require("./specialEffectDefinitions/specialEffects");
var _analytics = require("./analytics");
var _versionDescription = require("./analytics/versionDescription");
var _graphs = require("./simulation/graphs");
var _actions = require("./simulation/actions");
var _sensors = require("./constants/sensors");
var _paths = require("./simulation/paths");
var _assignment = require("./teams/assignment");